export enum WheelEventType {
    RIM_BRAKE_COLOR_CHANGE = 'rimBrakeColorChange',
    RIM_MATERIAL = 'rimMaterial',
}
